export function getDomain(items: string[]): string[] {
  const domain = items.reduce((acc: string[], item: string) => {
    if (acc.indexOf(item) < 0) {
      acc.push(item);
    }
    return acc;
  }, []);
  return domain;
}
